<template>
  <section
    class="experiences__background section"
    :id="$t('anchors.business')"
    data-light-menu="false"
    :data-section="$t('anchors.business')"
  >
    <BusinessesBlock :content="content.experiences" />
    <HistoryBlock :content="content.history" />
  </section>
</template>

<script>
import BusinessesBlock from '@/components/blocks/BusinessesBlock.vue'
import HistoryBlock from '@/components/blocks/HistoryBlock.vue'

export default {
  name: 'IntroductionSection',
  components: { BusinessesBlock, HistoryBlock },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
}
</script>
